import CardWithFields from "components/General/CardWithFields";
import CardDisclaimerBase from "components/General/CardDisclaimerBase/CardDisclaimerBase";

import { stringFormattingToCurrency, getPaymentMode } from "js/formatting";
import { useTranslation, Trans } from "react-i18next";

export default function PaymentDetails({ paymentStream }) {
  const { t } = useTranslation();
  return (
    <CardWithFields
      additionalContent={
        <CardDisclaimerBase
          disclaimer={
            <>
              <Trans
                i18nKey="AgentPaymentDetails-dsc"
                components={{
                  break: <br />,
                }}
              />
            </>
          }
        />
      }
      ariaLabel={t("AgentPaymentDetails-label")}
      cardTitle={t("AgentPaymentDetails-card-title")}
      cardFields={[
        {
          title: t("AgentPaymentDetails-title-1"),
          value: paymentStream.map((stream, idx) => (
            <p key={`payment detail amount - ${idx + 1}`}>
              {stringFormattingToCurrency(parseFloat(stream.paymentAmount))}
            </p>
          )),
        },
        { title: "", value: <></> },
        {
          title: t("AgentPaymentDetails-title-2"),
          value: paymentStream.map((stream, idx) => (
            <p key={`payment detail mode - ${idx + 1}`}>
              {getPaymentMode(stream.paymentMethod)}
            </p>
          )),
        },
      ]}
    />
  );
}
